
/**
 * OrderLineItem model representing a line item in an order
 */
class OrderLineItem {
  constructor(data = {}) {
    this.id = data.id;
    this.order_id = data.order_id;
    this.product_id = data.product_id;
    this.quantity = data.quantity;
    this.cost = data.cost;
    this.price = data.price;
    this.total_price = data.total_price;
    this.note = data.note;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    this.product = data.product;
    this.order_type = data.order_type;
    this.convert_rate = data.convert_rate;
  }

  /**
   * Maps API data to model properties
   */
  mapData(data) {
    this.id = data.id;
    this.order_id = data.order_id;
    this.product_id = data.product_id;
    this.quantity = data.quantity;
    this.cost = data.cost;
    this.price = data.price;
    this.total_price = data.total_price;
    this.note = data.note;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    this.product = data.product;
    this.order_type = data.order_type;
    this.convert_rate = data.convert_rate;
  }
}

export default OrderLineItem;
